<template>
  <div id="app">
    <div v-if="$screen.width <= 768">
      <top-section-mobile />
      <div class="bg-mobile-bg bg-cover bg-no-repeat">
        <nav-section-mobile />
        <map-section-mobile />
        <boss-section-mobile />
        <monster-section-mobile />
        <champ-section-mobile />
        <npc-section-mobile />
      </div>
      <div class="bg-section-system-mobile bg-cover bg-no-repeat">
        <item-awaking-mobile />
        <guild-rework-mobile />
        <event-section-mobile />
      </div>
    </div>
    <transition name="fade">
      <navigation
        v-if="navActive"
        class="fixed right-0.1/10 2xl:top-2/10 xl:top-0 z-50 xl:block lg:hidden"
        :moveTo="moveTo"
        :activeSection="activeSection"
      />
    </transition>
    <full-page
      ref="fullpage"
      :options="options"
      v-if="$screen.width > 768"
      id="fullpage"
    >
      <div class="section">
        <top-section />
      </div>
      <div class="section bg-section-2 bg-no-repeat bg-cover bg-center">
        <div class="flex justify-center">
          <nav-section :moveTo="moveTo" />
        </div>
      </div>
      <div class="section bg-section-3 bg-no-repeat bg-cover">
        <div class="flex justify-center">
          <scenario-section />
        </div>
      </div>
      <div class="section">
        <map-section />
      </div>
      <div class="section">
        <div class="flex justify-center">
          <boss-section />
        </div>
      </div>
      <div class="section bg-section-6 bg-no-repeat bg-cover">
        <div class="flex justify-center">
          <monster-section />
        </div>
      </div>
      <div class="section">
        <champ-section />
      </div>
      <div class="section bg-section-8 bg-no-repeat bg-cover">
        <div class="flex justify-center">
          <npc-section />
        </div>
      </div>
      <div
        class="section horizontal-slide relative bg-section-system bg-no-repeat bg-cover"
      >
        <div class="slide" data-anchor="ItemAwakening">
          <item-awakening-1 />
        </div>
        <div class="slide" data-anchor="ItemAwakening">
          <item-awakening-2 />
        </div>
        <div
          class="absolute w-226 xl:bottom-0.5/10 lg:bottom-0.3/10 inset-x-0 mx-auto"
        >
          <slide-page
            :page="awakeningPage"
            :slideNumber="awakeningActive"
            :moveToSlide="moveToSlideAwakening"
          />
        </div>
      </div>
      <div
        class="section horizontal-slide relative bg-section-system bg-no-repeat bg-cover"
      >
        <div class="slide" data-anchor="guildRework">
          <guild-rework-1 />
        </div>
        <div class="slide" data-anchor="guildRework">
          <guild-rework-2 />
        </div>
        <div class="slide" data-anchor="guildRework">
          <guild-rework-3 />
        </div>
        <div class="slide" data-anchor="guildRework">
          <guild-rework-4 />
        </div>
        <div class="slide" data-anchor="guildRework">
          <guild-rework-5 />
        </div>
        <div
          class="absolute w-440 xl:bottom-0.5/10 lg:bottom-0.3/10 inset-x-0 mx-auto"
        >
          <slide-page
            :page="guildPage"
            :slideNumber="guildActive"
            :moveToSlide="moveToSlideGuild"
          />
        </div>
      </div>
      <div class="section fp-auto-height">
        <event-link />
      </div>
    </full-page>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BossSection from './containers/BossSection.vue';
import MapSection from './containers/MapSection.vue';
import ScenarioSection from './containers/ScenarioSection.vue';
import TopSection from './containers/TopSection.vue';
import NavSection from './containers/NavSection';
import MonsterSection from './containers/MonsterSection.vue';
import ChampSection from './containers/ChampSection.vue';
import NpcSection from './containers/NpcSection.vue';
import ItemAwakening1 from './containers/ItemAwakening1.vue';
import ItemAwakening2 from './containers/ItemAwakening2.vue';
import SectionTag from './components/SectionTag.vue';
import GuildRework1 from './containers/GuildRework1.vue';
import GuildRework2 from './containers/GuildRework2.vue';
import GuildRework3 from './containers/GuildRework3.vue';
import GuildRework4 from './containers/GuildRework4.vue';
import GuildRework5 from './containers/GuildRework5.vue';
import EventLink from './containers/EventLink.vue';
import SlidePage from './components/SlidePage.vue';
import Navigation from './components/Navigation.vue';
// mobile component
import TopSectionMobile from './containers/mobile/TopSection.mobile';
import NavSectionMobile from './containers/mobile/NavSection.mobile';
import MapSectionMobile from './containers/mobile/MapSection.mobile.vue';
import BossSectionMobile from './containers/mobile/BossSection.mobile.vue';
import MonsterSectionMobile from './containers/mobile/MonsterSection.mobile.vue';
import ChampSectionMobile from './containers/mobile/ChampSection.mobile.vue';
import NpcSectionMobile from './containers/mobile/NpcSection.mobile.vue';
import ItemAwakingMobile from './containers/mobile/ItemAwaking.mobile.vue';
import GuildReworkMobile from './containers/mobile/GuildRework.mobile.vue';
import EventSectionMobile from './containers/mobile/EventSection.mobile.vue';

export default {
  name: 'App',
  components: {
    TopSection,
    NavSection,
    BossSection,
    MapSection,
    ScenarioSection,
    MonsterSection,
    ChampSection,
    NpcSection,
    ItemAwakening1,
    ItemAwakening2,
    SectionTag,
    GuildRework1,
    GuildRework2,
    GuildRework3,
    GuildRework4,
    GuildRework5,
    EventLink,
    SlidePage,
    Navigation,
    NavSectionMobile,
    MapSectionMobile,
    BossSectionMobile,
    MonsterSectionMobile,
    ChampSectionMobile,
    NpcSectionMobile,
    ItemAwakingMobile,
    GuildReworkMobile,
    EventSectionMobile,
    TopSectionMobile,
  },
  data() {
    return {
      awakeningPage: [0, 1],
      guildPage: [0, 1, 2, 3, 4],
      awakeningActive: 0,
      guildActive: 0,
      navActive: false,
      activeSection: 0,
      options: {
        licenseKey: '22B14707-790C4BCB-A9C092BF-C125B4EC',
        anchors: [
          'top',
          'page2',
          'page3',
          'page4',
          'page5',
          'page6',
          'page7',
          'page8',
          'page9',
          'page10',
          'events',
        ],
        scrollingSpeed: 700,
        css3: true,
        easingcss3: 'cubic-bezier(0.7, 0, 0.84, 0)',
        afterLoad: this.afterLoad,
        afterSlideLoad: this.afterSlideLoad,
        scrollHorizontally: true,
        scrollHorizontallyKey:
          'cGFwYXlhcGxheS5jb21fODgxYzJOeWIyeHNTRzl5YVhwdmJuUmhiR3g1OVk1',
      },
    };
  },
  watch: {
    pageNumber: function(newVal, oldVal) {
      if (newVal >= 2) {
        this.navActive = true;
      } else {
        this.navActive = false;
      }
    },

    '$screen.width'(newVal, oldVal) {
      console.log('Width changed', newVal);
      if (newVal >= 768) {
        this.$store.commit('ANIMATION/TOP_SECTION');
      }
    },
  },
  methods: {
    afterLoad: function(origin, destination, direction) {
      //console.log(destination.index);
      this.$store.commit('APP_CONFIG/SET_PAGE', destination.index);
    },
    afterSlideLoad: function(section, origin, destination, direction) {
      //console.log(destination);
      //console.log(destination.index);
      if (destination.anchor.includes('ItemAwakening')) {
        this.awakeningActive = destination.index;
      }
      if (destination.anchor.includes('guildRework')) {
        this.guildActive = destination.index;
      }
    },
    moveTo: function(nav) {
      const number = parseInt(nav);
      console.log('nav move to', number);
      fullpage_api.moveTo(number, 0);
    },
    moveToSlideAwakening: function(index) {
      // console.log(index);
      fullpage_api.moveTo('page9', index);
    },
    moveToSlideGuild: function(index) {
      // console.log(index);
      fullpage_api.moveTo('page10', index);
    },
  },
  computed: {
    ...mapState({
      pageNumber: state => state.AppConfig.pageNumber,
    }),
  },
};
</script>

<style lang="postcss" scoped>
#app {
  padding: 0;
  margin: 0;
}
</style>
